<template>
  <section class="fill">

    <!-- Navegacion principal -->
    <div>
      <b-navbar toggleable="lg" type="dark" variant="info" class="bg-utb-blue">
        <b-navbar-brand class="app-name">Actualiza UTB</b-navbar-brand>
        <b-collapse id="nav-collapse" is-nav>

          <!-- <b-navbar-nav>
            <b-nav-item href="#">Encuestras</b-nav-item>
            <b-nav-item href="#" >Codigo Qr</b-nav-item>
          </b-navbar-nav> -->

          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown right>
              <template #button-content>
                <label>Perfil</label>
              </template>
              <!-- <b-dropdown-item href="#">Perfil</b-dropdown-item> -->
              <b-dropdown-item @click="logout()">Cerrar Sesion</b-dropdown-item>
            </b-nav-item-dropdown>

          </b-navbar-nav>

        </b-collapse>

      </b-navbar>
    </div>

    <!-- Inferior -->
    <b-container fluid>
      <b-row>
        <!-- Menu Lateral principal -->
        <b-col lg="2" md="3" class="sidebar">
          <b-nav vertical>

            <b-nav-item class="mt-3" :to="{ name: 'dashboard' }"><strong>Dashboard</strong></b-nav-item>

            <b-nav-text v-if="$auth.can('usuarios') || $auth.can('roles') || $auth.can('alertas')">Sistema</b-nav-text>
            <b-nav-item :to="{ name: 'usuarios' }" v-if="$auth.can('usuarios')">Usuarios</b-nav-item>
            <b-nav-item :to="{ name: 'roles' }" v-if="$auth.can('roles')">Roles</b-nav-item>
            <b-nav-item v-if="$auth.can('api_key')" @click="mostrarApiKey">Generar API KEY</b-nav-item>
            <b-nav-item :to="{ name: 'alertas' }" v-if="$auth.can('alertas')">Alertas</b-nav-item>
            <!-- <b-nav-item class="pl-0" @click.prevent="cambiarPassword">Cambiar password</b-nav-item> -->

            <!-- Encuestas -->
            <b-nav-text v-if="$auth.can('exportar_encuestas') || $auth.can('lanzar_encuestas') || $auth.can('encuestas_dinamicas')">Encuestas</b-nav-text>
            <b-nav-item :to="{ name: 'caracterizaciones' }" v-if="$auth.can('exportar_encuestas')">Exportar datos de caracterización</b-nav-item>
            <!--b-nav-item :to="{ name: 'periodicas' }" v-if="$auth.can('exportar_encuestas')">Periódicas</b-nav-item-->
            <b-nav-item :to="{ name: 'dinamicas' }" v-if="$auth.can('dinamicas')">Encuestas dinámicas</b-nav-item>
            <b-nav-item :to="{ name: 'lanzar-encuestas' }" v-if="$auth.can('lanzar_encuestas')">Realizar encuestas</b-nav-item>

            <!-- Autorizaciones -->
            <b-nav-text v-if="$auth.can('ver_autorizaciones') || $auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_profesores') || $auth.can('solicitar_autorizacion_empleado') || $auth.can('solicitar_autorizacion_especial') || $auth.can('solicitar_autorizacion_visitante') || $auth.can('solicitar_autorizacion_todos') || $auth.can('solicitar_desautorizaciones') || $auth.can('validar_autorizaciones_estudiante') || $auth.can('validar_autorizaciones_profesor') || $auth.can('validar_autorizaciones_empleado') || $auth.can('validar_autorizaciones_especial') || $auth.can('validar_autorizaciones_visitante')">Gestión de autorizaciones</b-nav-text>
            <b-nav-item :to="{ name: 'autorizaciones' }" v-if="$auth.can('ver_autorizaciones')">Lista de autorizaciones</b-nav-item>
            <b-nav-item :to="{ name: 'autorizaciones-solicitar' }" v-if="$auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_profesor') || $auth.can('solicitar_autorizacion_empleado') || $auth.can('solicitar_autorizacion_especial') || $auth.can('solicitar_autorizacion_visitante') || $auth.can('solicitar_autorizacion_todos')">Solicitudes de autorización</b-nav-item>
            <b-nav-item :to="{ name: 'desautorizaciones-solicitar' }" v-if="$auth.can('solicitar_desautorizaciones') && ($auth.can('solicitar_autorizacion_estudiante') || $auth.can('solicitar_autorizacion_profesor') || $auth.can('solicitar_autorizacion_empleado') || $auth.can('solicitar_autorizacion_especial') || $auth.can('solicitar_autorizacion_visitante') || $auth.can('solicitar_autorizacion_todos'))">Solicitudes de desautorización</b-nav-item>
            <b-nav-item :to="{ name: 'validacion-solicitudes' }" v-if="$auth.can('validar_autorizaciones_estudiante') || $auth.can('validar_autorizaciones_profesor') || $auth.can('validar_autorizaciones_empleado') || $auth.can('validar_autorizaciones_especial') || $auth.can('validar_autorizaciones_visitante')">Aceptación de solicitudes</b-nav-item>

            <!-- Control de acceso -->
            <b-nav-text v-if="$auth.can('leer_qr') || $auth.can('ajustes_control_acceso')">Control de acceso</b-nav-text>
            <b-nav-item :to="{ name: 'registro-entrada' }" v-if="$auth.can('leer_qr')">Registro de entrada</b-nav-item>
            <b-nav-item :to="{ name: 'registro-salida' }" v-if="$auth.can('leer_qr')">Registro de salida</b-nav-item>
            <b-nav-item :to="{ name: 'ajustes-control-acceso' }" v-if="$auth.can('ajustes_control_acceso')">Control de aforo</b-nav-item>

            <!-- <b-nav-text>Ajustes</b-nav-text> -->
            <!-- <b-nav-item :to="{ name: 'datos-sistema' }" v-if="$auth.can('datos_sistema')">Datos del Sistema</b-nav-item> -->
            <!-- <b-nav-item :to="{ name: 'ajustes-encuestas' }" v-if="$auth.can('ajustes_encuestas')">Ajustes de encuestas</b-nav-item> -->

          </b-nav>

        </b-col>

        <!-- Pantallas principal -->
        <b-col lg="10" md="9" sm="12">
          <b-card class="m-3 bg-light">
            <router-view></router-view>
          </b-card>
        </b-col>

      </b-row>
    </b-container>

    <!-- Modal cambio de pass -->
    <b-modal v-model="mainModal" size="md" no-close-on-backdrop>
      <b-form ref="mainForm" @submit.prevent="guardar">
        <b-form-group label="Password actual:" label-for="input-password" :invalid-feedback="errores.password">
          <b-form-input type="password" id="input-password" v-model="usuario.password" :state="$empty(errores.password)" trim></b-form-input>
        </b-form-group>
        <b-form-group label="Nuevo password:" label-for="input-nuevo-password" :invalid-feedback="errores.nuevoPassword">
          <b-form-input type="password" id="input-nuevo-password" v-model="usuario.nuevoPassword" :state="$empty(errores.nuevoPassword)" trim></b-form-input>
        </b-form-group>
        <b-form-group label="Confirm password:" label-for="input-confirmar-password" :invalid-feedback="errores.confirmarPassword">
          <b-form-input type="password" id="input-confirmar-password" v-model="usuario.confirmarPassword" :state="$empty(errores.confirmarPassword)" trim></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="submit()">OK</b-button>
        <b-button variant="danger" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </section>
</template>




<script lang="ts">
import axios from 'axios'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { url } from '../../services/url_service'

@Component
export default class Container extends Vue {
  public mainModal: boolean = false
  public errores: any = {}
  public usuario: any = {}

  public async cambiarPassword() {
    this.usuario = {}
    this.errores = {}
    this.mainModal = true
  }

  public submit() {
    (this.$refs.mainForm as Element).dispatchEvent(new window.Event('submit'))
  }

  public async guardar() {
    try {
      this.errores = {}
      let response = await axios.post(
        url.create(`/internal/usuarios/password`),
        this.usuario
      )
      this.mainModal = false
      this.$bvToast.toast('Su password ha sido cambiado correctamente', {
        title: 'Cambio de password',
        variant: 'success',
      })
    } catch (ex) {
      this.errores = ex.response.data
    }
  }

  public async mostrarApiKey() {
    let res = await this.$bvModal.msgBoxConfirm('Esta acción generará un API Key que borrará el anterior, recuerde que una vez generado solo lo podrá ver una vez. ¿Desea continuar?', {
      size: 'lg',
      okVariant: 'success',
      headerClass: 'p-2 border-bottom-0',
      footerClass: 'p-2 border-top-0',
      centered: true
    })
    if (res) {
      let response = await axios.get(
        url.create(`/internal/api_key`),
        this.usuario
      )
      const h = this.$createElement;
      const message = h('p', { domProps: { innerHTML: `Su API Key es<br /><strong>${response.data['api_key']}</strong><br />copielo y guardelo en un lugar seguro, una ves cierre este dialogo no lo podrá ver nuevamente` } })
      this.$bvModal.msgBoxOk([message], {
        size: 'lg',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    }
  }

  public async logout() {
    await this.$auth.unAuthenticate()
    this.$router.push({ name: 'login' })
  }
}
</script>

<style lang="scss">
.sidebar {
  background-color: #ffffff;

  & .navbar-text {
    padding: 0.8rem 0;
  }
  & .nav-link {
    padding: 0.5rem 0.8rem;
  }
}
</style>